export default {
  namespaced: true, // 开启命名空间
  state: {
    appData: {
      platformConfiguration: {
        homePageGifImg: "",
        homePageWxImg: "",
        websiteLogo: "",
        topImg: "",
      },
    },
  },
  mutations: {
    setAppData(state, data) {
      state.appData = data;
    },
  },
  actions: {},
  getters: {
    appData: (state) => state.appData,
  },
};
